<template>
  <div class="common-card">
    <reset-email-by-admin url="/" @reset-data="refetchData" role="員工" :reset-data="resetData" />
    <staff-password-edit :user-info="userInfo" />
    <modal-filter
      :filter_gender_id.sync="filter_gender_id"
      :filter_worker_status.sync="filter_worker_status"
      :filter_bank_id.sync="filter_bank_id"
      :filter_payment_method_id.sync="filter_payment_method_id"
      :genderOptions="genderOptions"
      :bankOptions="bankOptions"
      :paymentMethodStatusOptions="paymentMethodStatusOptions"
      @refetch-data="refetchData"
    />
    <b-card class="top mb-0">
      <div class="d-flex flex-wrap align-items-center justify-content-between">
        <div class="d-flex mb-1 mb-sm-0 align-items-center">
          <h4 class="font-weight-bolder ml-1 text-nowrap mb-0">
            <font-awesome-icon
              class="mr-50"
              icon="fa-solid fa-people-carry-box"
            />
            員工
          </h4>
          <div class="d-flex ml-3 align-items-center">
            <label>顯示</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>條目</label>
          </div>
        </div>
        <div class="d-flex mobile-w100 flex-wrap mt-1 mt-lg-0">
          <b-form-input
            v-model="searchQuery"
            class="search-form mb-1 mb-sm-0 mr-sm-1"
            placeholder="搜尋"
          />
          <b-button
            variant="primary"
            class="mobile-w100 mb-1 mb-sm-0 mr-sm-1"
            @click="$bvModal.show('modal-filter')"
            ><feather-icon
              class="mr-1"
              icon="filterIcon"
              size="18"
            ></feather-icon
            >篩選</b-button
          >
          <b-button
            class="mobile-w100 mr-sm-1 mb-1 mb-sm-0"
            :to="{ name: 'staff-create' }"
            v-if="ability.can('create', 'setting_staffs')"
          >
            <feather-icon class="mr-1" icon="plusIcon" size="18"></feather-icon
            >新增員工</b-button
          >
          <b-button
            class="mobile-w100"
            @click="exportReport"
            v-if="ability.can('export', 'setting_staffs')"
          >
            <feather-icon class="" icon="plusIcon" size="18"></feather-icon
            >導出記錄</b-button
          >
        </div>
      </div>
    </b-card>

    <b-card no-body class="card-statistics bottom">
      <b-card-body class="p-2">
        <b-table
          ref="refStaffListTable"
          class="position-relative"
          :items="staffsList"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="未找到匹配的記錄"
          :sort-desc.sync="isSortDirDesc"
        >
          <template #cell(locked)="data">
            <feather-icon
              v-if="data.item.locked"
              icon="LockIcon"
              size="18"
              class="mr-50 text-danger"
            />
          </template>
          <template #cell(is_active)="data">
            <span
              :class="`${data.item.is_active ? 'text-success' : 'text-danger'}`"
              >{{ data.item.is_active ? "在職" : "離職" }}</span
            >
          </template>
          <template #cell(roles)="data">
            <span
              v-if="data.item.user_roles && data.item.user_roles.length > 0"
              >{{ data.item.user_roles[0].name }}</span
            >
          </template>

          <template #cell(is_active)="data">
            <feather-icon
              v-if="data.item.is_active"
              icon="CheckIcon"
              size="18"
              class="mr-50 text-success"
            />
          </template>
          <template #cell(actions)="data">
            <b-dropdown
              :class="`action-trigger-btn ${
                staffsList.length <= 3 ? 'hor' : 'ver'
              }`"
              :right="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="EyeIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>
              <!-- <b-dropdown-item
                v-if="ability.can('read', 'setting_staffs')"
                :to="{
                  name: 'staff-view',
                  params: { id: data.item.id },
                }"
              >
                <feather-icon icon="FileTextIcon" />
                <span class="align-middle ml-50">詳細資料</span>
              </b-dropdown-item> -->
              <b-dropdown-item
                v-if="ability.can('update', 'setting_staffs')"
                :to="{
                  name: 'staff-edit',
                  params: { id: data.item.id },
                }"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">修改資料</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="
                  ability.can('unlock', 'setting_staffs') && data.item.locked
                "
                @click="cleanLocked(data.item.id)"
              >
                <feather-icon icon="LockIcon" />
                <span class="align-middle ml-50">解封</span>
              </b-dropdown-item>

              <b-dropdown-item
                v-if="ability.can('reset_email', 'setting_staffs')"
                @click="triggerResetEmailModal(data.item)"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">重設電郵</span>
              </b-dropdown-item>


              <b-dropdown-item
                v-if="ability.can('reset_password', 'setting_staffs')"
                @click="triggerResetPasswordModal(data.item)"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">修改密碼</span>
              </b-dropdown-item>

              <b-dropdown-item
                v-if="ability.can('update', 'setting_staffs') && showToggleActive(data.item)"
                @click="toggleStaffActive(data.item)"
              >
                <feather-icon icon="RefreshCwIcon" />
                <span class="align-middle ml-50">切換在職狀態</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >在{{ dataMeta.of }}個記錄中，正在顯示 {{ dataMeta.from }} 至
                {{ dataMeta.to }}個記錄</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRow"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BCardBody,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import useStaffsList from "./useStaffsList";
import ModalFilter from "../modal/ModalFilter.vue";
import staffStoreModule from "../staffStoreModule";
import StaffPasswordEdit from "./StaffPasswordEdit.vue";
import ResetEmailByAdmin from "@/views/user/resetEmailbyAdmin.vue";

export default {
  components: {
    ModalFilter,
    BCard,
    BCardBody,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
    StaffPasswordEdit,
    ResetEmailByAdmin,
  },
  data() {
    return {
      userInfo: { id: 0, password: "", password_confirmation: "" },
      resetData: { id: 0, email: "", vertification_code: "" },
    };
  },
  methods: {
    triggerResetEmailModal(item) {
      this.resetData = {...item, role_name: item.user_roles && item.user_roles[0].name};
      this.$bvModal.show(`modal-reset-email-admin`);
    },
    cleanLocked(id) {
      this.$store
        .dispatch("app/cleanLocked", { id })
        .then((response) => {
          this.$swal({
            text: response.data.message,
            icon: "success",
            confirmButtonText: "確定",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            showClass: {
              popup: "animate__animated animate__bounceIn",
            },
            buttonsStyling: false,
          });
          this.refetchData();
        })
        .catch((error) => {
          this.$swal({
            text: error.response.data.message,
            icon: "error",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            showClass: {
              popup: "animate__animated animate__bounceIn",
            },
            buttonsStyling: false,
          });
        });
    },
    exportReport() {
      this.$swal({
        title: "確定導出Excel?",
        showCancelButton: true,
        confirmButtonText: "下載",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          this.$store
            .dispatch("staff/exportStaffs", {
              perPage: this.perPage,
              page: this.currentPage,
              sortBy: this.sortBy,
              sortDesc: this.isSortDirDesc,
            })
            .then((response) => {
              // create file link in browser's memory
              const href = URL.createObjectURL(response.data);
              // create "a" HTLM element with href to file & click
              const link = document.createElement("a");
              link.href = href;
              const current_datetime = new Date();
              const formatted_date =
                current_datetime.getFullYear() +
                "-" +
                (current_datetime.getMonth() + 1) +
                "-" +
                current_datetime.getDate() +
                " " +
                current_datetime.getHours() +
                "-" +
                current_datetime.getMinutes() +
                "-" +
                current_datetime.getSeconds();
              link.setAttribute(
                "download",
                "staff_" + formatted_date + ".xlsx"
              );
              document.body.appendChild(link);
              link.click();

              // clean up "a" element & remove ObjectURL
              document.body.removeChild(link);
              URL.revokeObjectURL(href);
            })
            .catch((error) => {
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    triggerResetPasswordModal(item) {
      console.log("triggerResetPasswordModal", item);
      this.userInfo.id = item.id;
      this.userInfo.name = item.name_cn;
      this.userInfo.password = "";
      this.userInfo.password_confirmation = "";
      this.$bvModal.show("modal-reset-staff-password");
    },
    // 特殊條件：員工編號為 WFDC 的員工不顯示此選項
    showToggleActive(item) {
      return item.id !== 31
    },
    async toggleStaffActive(staff) {
      const isActive = !!staff.is_active
      const targetText = isActive ? '離職' : '在職'
      const number = staff.user_number || ''
      const name = staff.name_cn || staff.name || ''

      const result = await this.$swal({
        title: '確認操作',
        html: `是否將 <strong>[${number}]：${name}</strong> 改為 <strong>${targetText}</strong>？`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '確認',
        cancelButtonText: '取消',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-secondary ml-1'
        },
        buttonsStyling: false
      })

      if (!result.value) return

      try {
        await this.$store.dispatch('staff/toggleActive', { id: staff.id })
        this.$swal({
          title: '已更新',
          text: `員工 ${name} 已切換為 ${targetText}`,
          icon: 'success',
          customClass: { confirmButton: 'btn btn-primary' }
        })
        this.refetchData()
      } catch (error) {
        this.$swal({
          title: '更新失敗',
          text: error.response?.data?.message || '切換在職狀態時發生錯誤',
          icon: 'error',
          customClass: { confirmButton: 'btn btn-primary' }
        })
      }
    },
    removeStaff(staff) {
      this.$swal({
        title: "確定移除員工？",
        html: `您即將移除員工：<strong>${staff.name_cn || staff.name}</strong><br><br>
               <small class="text-muted">注意：這是軟刪除操作，員工記錄將被隱藏但不會永久刪除，<br>
               相關的薪資記錄和其他資料將保持完整。</small>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "確定移除",
        cancelButtonText: "取消",
        confirmButtonColor: "#dc3545",
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn btn-outline-secondary ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("staff/deleteStaff", { id: staff.id })
            .then(() => {
              this.$swal({
                title: "移除成功",
                text: `員工 ${staff.name_cn || staff.name} 已成功移除`,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.refetchData();
            })
            .catch((error) => {
              this.$swal({
                title: "移除失敗",
                text: error.response?.data?.message || "移除員工時發生錯誤",
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = "staff";

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, staffStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });

    const {
      fetchStaffs,
      tableColumns,
      perPage,
      currentPage,
      totalRow,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      staffsList,
      refStaffListTable,
      refetchData,
      ability,
      refetchOption,
      filter_gender_id,
      filter_bank_id,
      filter_payment_method_id,
      filter_worker_status,
      genderOptions,
      bankOptions,
      paymentMethodStatusOptions,
    } = useStaffsList();

    return {
      fetchStaffs,
      tableColumns,
      perPage,
      currentPage,
      totalRow,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      staffsList,
      refStaffListTable,
      refetchData,
      ability,
      refetchOption,
      filter_gender_id,
      filter_bank_id,
      filter_payment_method_id,
      filter_worker_status,
      genderOptions,
      bankOptions,
      paymentMethodStatusOptions,
    };
  },
};

</script>


<style lang="scss" scoped>

.per-page-selector {
  width: 100px;
}

// @media screen and (max-width: 768px) {

// }
// @media screen and (max-width: 575px) {

// }
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@/assets/scss/variables/_variables.scss";
</style>
